import React, { useState } from 'react';
import './Header.css';

function Header({ setCurrentSection }) {
  const [menuOpen, setMenuOpen] = useState(false);

  const handleNavClick = (section) => {
    setCurrentSection(section);
    setMenuOpen(false);
  };

  return (
    <header className="header">
      <div className="header-container">
        <div className="logo">
          <h1>BREAK PLACE</h1>
          <p className="tagline">TAKE A BREAK - CHOOSE BREAK PLACE</p>
        </div>

        <button 
          className="menu-toggle"
          onClick={() => setMenuOpen(!menuOpen)}
          aria-label="Toggle menu"
        >
          <span></span>
          <span></span>
          <span></span>
        </button>

        <nav className={`nav ${menuOpen ? 'open' : ''}`}>
          <button 
            className="nav-btn"
            onClick={() => handleNavClick('menu')}
          >
            Meniu
          </button>
          <button 
            className="nav-btn"
            onClick={() => handleNavClick('qr')}
          >
            Cod QR
          </button>
        </nav>
      </div>
    </header>
  );
}

export default Header;
